// ثبت اعتبار و تخصیص اعتبارات تملک دارایی‌های سرمایه‌ای
import React from 'react';
import BudgetTransaction from './BudgetTransaction';

export default function BudgetTamalokCredit({ user, onBack }) {
  return <BudgetTransaction user={user} onBack={onBack} kind={1} />;
}
